import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { get } from 'api/request';
import SaveModal from 'components/common/modals/SaveModal';
import { useSubscriptions } from 'contexts/SubscriptionContext';
import ProductCardContainer from '../starter-kit/select-product/ProductCardContainer';
import { useRecoilValue } from 'recoil';
import { formState } from 'state';
import { useField } from 'hooks/useContentfulApi';

export default function SubscriptionOrderProductModal({ subscriptions, loading, save, close }) {
  const [data] = useField('banner4Ref');
  const form = useRecoilValue(formState);
  const { state, dispatch } = useSubscriptions();

  const [items, setItems] = useState([]);

  const {
    countryInfo: { name: country },
    repDID,
    locale,
  } = form;

  useEffect(() => {
    if (!isEmpty(country)) {
      getProducts();
    }
  }, [country, locale]);

  useEffect(() => {
    if (!isEmpty(subscriptions)) {
      dispatch({ type: 'replaceSubscriptions', subscriptions: subscriptions });
    }
  }, []);

  const getProducts = async () => {
    get(`/api/enrollmentGetProducts/:${country}/:${repDID}/:${locale}`).then((res) => {
      if (typeof res !== 'string') {
        sort(res);
      }
    });
  };

  // Merge Sort
  const sort = (arr) => {
    const filterArr = arr.filter(
      (product) =>
        (product.SignupOptionalItem && product.SignupAutoshipOption) ||
        (!product.SignupOptionalItem && product.SignupAutoshipOption),
    );
    const selectedIds = subscriptions.map((product) => product.ProductID);

    let left = [];
    let right = [];

    filterArr.forEach((product) => {
      if (selectedIds.includes(product.ProductID)) {
        left.push(product);
      } else {
        right.push(product);
      }
    });

    setItems(left.concat(right));
  };

  const { title, buttonText, item1, item6, item7 } = data?.fields;

  return (
    <SaveModal
      loading={loading}
      onSave={() => save(state.subscriptions)}
      onClose={() => close()}
      title={title}
      saveText={buttonText}
    >
      <div className="grid tab-card-small mb-40">
        {items.map((item, index) => {
          return (
            <ProductCardContainer
              subscribeSaveText={item7}
              addToTodaysOrderText={item6}
              subscribeText={item1}
              data={item}
              autoSubscribe={true}
              disableSubscribe={true}
              key={index}
              inModal={true}
              subscription
            />
          );
        })}
      </div>
    </SaveModal>
  );
}
